export const toUsers = users =>
  users.map(user => ({
    value: user.id,
    label: user.userName
  }))

export const toResult = data => {
  return Object.fromEntries(
    Object.entries(data)
      .map(([projectName, projectData]) => {
        const [firstEntry] = projectData.timeTrackerList

        const projectNumber = firstEntry?.projectNumber || ''

        const newProjectName = projectNumber ? `${projectNumber} - ${projectName}` : projectName

        return [newProjectName, { ...projectData }]
      })
      .sort(([a], [b]) => a.localeCompare(b))
  )
}
